<div class="form-title">
  <div class="form-title-text">{{ title }}</div>
</div>
<div class="under-space">{{ text }}</div>
<div class="border-top">
  <button class="button" mat-button (click)="close.emit()">
    {{ okLabel }}
  </button>
</div>
